import { render, staticRenderFns } from "./MessageHistoryOtherUserList.vue?vue&type=template&id=c7921b74&scoped=true&lang=pug"
import script from "./MessageHistoryOtherUserList.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryOtherUserList.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryOtherUserList.vue?vue&type=style&index=0&id=c7921b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7921b74",
  null
  
)

export default component.exports